import { useState } from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from 'react-icons/fa';

const API_URL = import.meta.env.VITE_API_URL;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
    website: ''
  });
  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState('');

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const validate = () => {
    const nextErrors = {};

    if (!formData.name.trim()) nextErrors.name = 'Укажите имя.';
    else if (formData.name.length > 100) nextErrors.name = 'Слишком длинное имя.';

    if (!formData.email.trim()) nextErrors.email = 'Укажите email.';
    else if (!EMAIL_REGEX.test(formData.email)) nextErrors.email = 'Некорректный email.';

    if (!formData.message.trim()) nextErrors.message = 'Введите сообщение.';
    else if (formData.message.length > 2000) nextErrors.message = 'Слишком длинное сообщение (максимум 2000 символов).';

    setErrors(nextErrors);

    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.website) return;

    if (!validate()) {
      setStatus('');

      return;
    }

    setStatus('Отправка...');

    try {
      const response = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok) {
        setStatus('Сообщение отправлено успешно!');
        setFormData({ name: '', email: '', message: '', website: '' });
        setErrors({});
      }

      else setStatus(result.error || 'Ошибка отправки. Попробуйте снова.');
    } catch (error) {
      setStatus('Ошибка отправки. Проверьте подключение.');
    }
  };

  const contactInfo = [
    { icon: <FaMapMarkerAlt />, title: 'Наш адрес', description: 'г. Усть-Илимск, ул. Черехумовая, 1' },
    { icon: <FaPhoneAlt />, title: 'Номер телефона', description: '+7 (904) 146-49-64' },
    { icon: <FaEnvelope />, title: 'Электронная почта', description: 'admin@hisphere.net' }
  ];

  return (
    <section className='py-32 relative overflow-hidden'>
      <div className='before:content-[""] before:absolute before:-bottom-80 before:-left-80 before:w-[800px] before:h-[800px] before:bg-gradient-radial before:from-sky-400/10 before:to-transparent before:z-0 before:animate-pulse'></div>
      <div className='container mx-auto px-8 max-w-7xl relative z-10'>
        <div className='text-center mb-20 animate'>
          <h2 className='section-title'>
            Связаться с нами
          </h2>
          <p className='text-xl text-gray-600 dark:text-gray-400 max-w-3xl mx-auto'>
            Мы здесь, чтобы помочь! Свяжитесь с нами по любым вопросам.
          </p>
        </div>
        <div className='flex flex-col lg:flex-row gap-12'>
          <div className='flex-1 flex flex-col gap-8'>
            {contactInfo.map((info, index) => (
              <div
                key={index}
                className='info-item glass-card p-6 rounded-2xl animate'
              >
                <div className='w-14 h-14 bg-gradient-to-br from-cyan-400 to-sky-500 rounded-xl flex items-center justify-center text-[#0b1e3d] text-xl transition-all duration-300 hover:rotate-12 hover:shadow-lg'>
                  {info.icon}
                </div>
                <div>
                  <h3 className='text-xl font-montserrat font-bold mb-2 text-gray-900 dark:text-white'>{info.title}</h3>
                  <p className='text-gray-600 dark:text-gray-400'>{info.description}</p>
                </div>
              </div>
            ))}
          </div>
          <form onSubmit={handleSubmit} className='relative flex-1 glass-panel p-8 rounded-3xl transition-all duration-300 animate'>
            <div className='flex flex-col lg:flex-row gap-6 mb-6'>
              <div className='flex-1'>
                <label className='block mb-2 font-semibold text-gray-900 dark:text-gray-200'>Имя</label>
                <input
                  type='text'
                  name='name'
                  value={formData.name}
                  onChange={handleChange}
                  className={`w-full p-3 border rounded-xl bg-gray-50/70 dark:bg-gray-700/50 text-gray-900 dark:text-gray-200 focus:outline-none focus:ring-2 transition-all duration-200 ${errors.name ? 'border-red-400 focus:border-red-400 focus:ring-red-400/20' : 'border-gray-200 dark:border-gray-600 focus:border-cyan-400 focus:ring-cyan-400/20'}`}
                  placeholder='Ваше имя'
                />
                {errors.name && <p className='mt-1 text-sm text-red-500'>{errors.name}</p>}
              </div>
              <div className='flex-1'>
                <label className='block mb-2 font-semibold text-gray-900 dark:text-gray-200'>Электронная почта</label>
                <input
                  type='email'
                  name='email'
                  value={formData.email}
                  onChange={handleChange}
                  className={`w-full p-3 border rounded-xl bg-gray-50/70 dark:bg-gray-700/50 text-gray-900 dark:text-gray-200 focus:outline-none focus:ring-2 transition-all duration-200 ${errors.email ? 'border-red-400 focus:border-red-400 focus:ring-red-400/20' : 'border-gray-200 dark:border-gray-600 focus:border-cyan-400 focus:ring-cyan-400/20'}`}
                  placeholder='Ваш email'
                />
                {errors.email && <p className='mt-1 text-sm text-red-500'>{errors.email}</p>}
              </div>
            </div>
            <div className='mb-6'>
              <label className='block mb-2 font-semibold text-gray-900 dark:text-gray-200'>Сообщение</label>
              <textarea
                name='message'
                value={formData.message}
                onChange={handleChange}
                className={`w-full p-3 border rounded-xl bg-gray-50/70 dark:bg-gray-700/50 text-gray-900 dark:text-gray-200 focus:outline-none focus:ring-2 transition-all duration-200 min-h-[180px] resize-y ${errors.message ? 'border-red-400 focus:border-red-400 focus:ring-red-400/20' : 'border-gray-200 dark:border-gray-600 focus:border-cyan-400 focus:ring-cyan-400/20'}`}
                placeholder='Ваше сообщение'
              ></textarea>
              {errors.message && <p className='mt-1 text-sm text-red-500'>{errors.message}</p>}
            </div>
            {/* Honeypot: скрыто визуально и от скринридеров, но видно ботам, которые заполняют все поля формы */}
            <input
              type='text'
              name='website'
              value={formData.website}
              onChange={handleChange}
              tabIndex='-1'
              autoComplete='off'
              aria-hidden='true'
              className='absolute -left-[9999px] w-px h-px opacity-0'
            />
            <button
              type='submit'
              className='bg-gradient-to-br from-cyan-400 to-sky-500 text-[#0b1e3d] font-bold py-3 px-6 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 hover:from-sky-500 hover:to-cyan-400 transition-all duration-300'
            >
              Отправить сообщение
            </button>
            {status && (
              <p className={`text-center mt-4 ${status.includes('успешно') ? 'text-green-500' : 'text-red-500'}`}>
                {status}
              </p>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
